module.exports = require("./fr-RE");